import { EJEnterWheelBonusState } from "states/wheelbonus/ej-enter-wheel-bonus-state";
import { BlastworksClientEvent } from "../ClientController";

export class SocialEnterWheelBonusState extends EJEnterWheelBonusState {
    public onEnter(cascadeSkip?: boolean): void {
        this.stateMachine.dispatchClientEvent(BlastworksClientEvent.BONUS_START);
        super.onEnter(cascadeSkip);
    }
}